<ng-container *ngIf="!contactTypeForm">
    <acabim-loading-view></acabim-loading-view>
</ng-container>

<ng-container *ngIf="contactTypeForm && !loading">
    <form [formGroup]="contactTypeForm">
        <p-toast key="contactTypeNameMissing" position="center"></p-toast>
        <acabim-form-block
                *ngIf="showStep1"
                class="cas-form-floating push-up-2"
                labelWidth="10"
                [labelAlign]="'right'"
                [colonize]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Name</acabim-form-input-label>
                <acabim-form-input-content [shortField]="true">
                    <input type="text" formControlName="name" id="contact-type-name">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Description</acabim-form-input-label>
                <acabim-form-input-content>
                    <input type="text" formControlName="description" id="contact-type-description">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button (click)="onCancel()">Cancel</button>
                <button
                    class="cas-button-action cas-button-right"
                    data-cy="_t-add-contact-type-step-1"
                    (click)="go(2)">Next</button>
            </div>
        </acabim-form-block>
        <acabim-form-block
                *ngIf="showStep2"
                labelWidth="10"
                [labelAlign]="'right'"
                [colonize]="true"
                [shortFields]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Roles</acabim-form-input-label>
                <acabim-form-input-content class="role-groups">
                    <ng-container *ngFor="let roleGroup of roleGroups">
                        <acabim-card [cardContent]="roleTemplate" cardHeading="{{roleGroup.name}}" class="role-group-card"></acabim-card>
                        <ng-template #roleTemplate>
                            <div class="roles">
                                <div *ngFor="let role of roleGroup.roles; let i=index" class="checkbox">
                                    <input
                                        type="checkbox"
                                        attr.data-cy="_t-role-{{role.id}}"
                                        [value]="role.id"
                                        [pTooltip]="role.long_description"
                                        (change)="onRoleChange(role.id)"
                                        [checked]="roleCheckboxes[role.id] === true">
                                    {{role.description}}
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button (click)="go(1)">Previous</button>
                <button (click)="onCancel()">Cancel</button>
                <button
                    class="cas-button-action cas-button-right"
                    data-cy="_t-add-contact-type-step-2"
                    (click)="onContactTypeAddSubmit()">Add</button>
            </div>
        </acabim-form-block>
    </form>
</ng-container>
